import { assignInlineVars } from "@vanilla-extract/dynamic";
import { type FC, type RefObject } from "react";
import { AnchorLinkItem } from "@root/shared/components/AnchorLinkItem";
import * as styles from "./styles.css";

type Props = {
  anchorLinks: AnchorLinkProps[];
  isFixed: boolean;
  anchorLinksRef: RefObject<HTMLDivElement>;
  className?: string;
  anchorLinkLength: number;
  size: "small" | "large";
};

type AnchorLinkProps = {
  iconName?: string;
  anchorLinkName: string;
  isCurrent: boolean;
  onClick: () => void;
};

export const Presentation: FC<Props> = ({
  anchorLinks,
  isFixed,
  anchorLinksRef,
  className,
  anchorLinkLength,
  size,
}) => (
  <div className={className}>
    <div ref={anchorLinksRef} className={`${styles.wrapper} ${isFixed ? "is-fixed" : ""}`}>
      <div
        className={styles.container}
        style={assignInlineVars({ [styles.size]: size === "large" ? "980px" : "800px" })}
      >
        <ul className={styles.ul}>
          {anchorLinks.map(({ iconName, anchorLinkName, isCurrent, onClick }) => (
            <AnchorLinkItem
              key={anchorLinkName}
              iconName={iconName}
              anchorLinkName={anchorLinkName}
              anchorLinkLength={anchorLinkLength}
              isCurrent={isCurrent}
              onClick={onClick}
            />
          ))}
        </ul>
      </div>
    </div>
  </div>
);
